import { render, staticRenderFns } from "./ExamDeferralCard.vue?vue&type=template&id=5c96cf48&scoped=true"
import script from "./ExamDeferralCard.vue?vue&type=script&lang=js"
export * from "./ExamDeferralCard.vue?vue&type=script&lang=js"
import style0 from "./ExamDeferralCard.vue?vue&type=style&index=0&id=5c96cf48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c96cf48",
  null
  
)

export default component.exports